import * as React from "react";

interface ProgressProps {
  value?: number;
  className?: string;
  indicatorClassName?: string;
}

export const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ value = 0, className = "", indicatorClassName = "" }, ref) => {
    return (
      <div ref={ref} className={`relative h-4 w-full overflow-hidden rounded-full bg-slate-100 ${className}`}>
        <div
          className={`absolute top-0 left-0 h-full transition-all duration-300 ease-out rounded-full ${indicatorClassName}`}
          style={{ width: `${value}%` }}
        />
      </div>
    );
  }
);

Progress.displayName = "Progress";
